let googleMapsPromise = null;
const apiKey = 'AIzaSyCcFYtJwXXlo1sKVHoWp7qJldVXKxfBOT4'

export function loadGoogleMapsScript() {
  if (window.google && window.google.maps) {
    return Promise.resolve();
  }

  if (googleMapsPromise) {
    return googleMapsPromise;
  }

  googleMapsPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Google Maps script failed to load"));
    document.head.appendChild(script);
  });

  return googleMapsPromise;
}